import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/auth-context";

const PrivateRoute: FC<{ children: any }> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, authReady } = useAuth();

  // Establishing the session is now a request to the API rather than a synchronous cookie
  // read, so this is a real (if short) wait on every load — show something for it.
  if (!authReady) {
    return (
      <div className="flex min-h-screen w-full items-center justify-center bg-muted">
        <Loader2 className="size-8 animate-spin text-primary" />
        <span className="sr-only">Loading</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
